import { connect } from "react-redux";
import { withRouter } from "react-router";
import { ApplicationStore } from "src/store";
import { getAccessoriesRequest } from "src/store/actions/accessories";
import { resetCreditAppAction, skipCreditAppAction } from "src/store/actions/creditApp/base";
import { toggleGPC } from "src/store/actions/onlineShopper/openGPC";
import { openSubModal } from "src/store/actions/onlineShopper/subModal";
import { getSelectedPaymentType } from "src/store/selectors/vehicles";
import { PaymentTypeOptions } from "Types/state";
import ContinueDeal from "./ContinueDeal";

function mapStateToProps(state: ApplicationStore) {
    const { accessories, account, currentDeal, creditApp, deal, onlineShopper, tradeIn, vehicles } = state;
    const { vin } = currentDeal;
    return {
        hasAvailableAccessories: !!accessories[vin!]?.available?.[getSelectedPaymentType(state, vin!)]?.length,
        account,
        creditAppStatus: creditApp.base.status,
        deal,
        isDrawerOpen: onlineShopper.isDrawerOpen,
        tradePending: tradeIn,
        vehicle: vehicles.entities[vin!],
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    openPaymentPlanReviewModal: (vin: string) => dispatch(openSubModal({ modalType: "paymentPlanReviewModal", vin })),
    resetCreditApp: () => dispatch(resetCreditAppAction()),
    skipCreditApplication: () => dispatch(skipCreditAppAction()),
    getAccessories: (uuid: string, vin: string, paymentType: PaymentTypeOptions) =>
        dispatch(getAccessoriesRequest(uuid, vin, paymentType)),
    toggleGPC: () => dispatch(toggleGPC()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContinueDeal));
